import React, { useState } from 'react'
import DataTable from '@ublique/components/DataTable'
import HeaderComponent from './HeaderComponent'

import { defaultTableConfigs } from './configs'
import 'pages/Administration/components/index.scss'

const Table = ({
  rowData,
  headerActions,
  onSelectionChanged,
  ...tableProps
}) => {
  const [selectedRows, setSelectedRows] = useState([])

  const onSelectionChangedFun = (rows) => {
    setSelectedRows(rows)
    onSelectionChanged(rows)
  }

  return (
    <div className='table-view'>
      <DataTable
        {...defaultTableConfigs}
        {...tableProps}
        canSearch={false}
        rowData={rowData || []}
        onSelectionChanged={onSelectionChangedFun}
        extraHeaderComponent={
          <HeaderComponent
            actions={headerActions}
            selectedSize={selectedRows.length}
          />
        }
      />
    </div>
  )
}

Table.defaultProps = {
  headerActions: {
    selected: [],
    empty: []
  },
  onSelectionChanged: () => {}
}

export default React.memo(Table)
